export default "__VITE_ASSET__iaWZJ3sJ__"